import React from 'react';
import PropTypes from 'prop-types';
import { SanitizeHtml, buildThumbnailUrl } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import LightBox from '@bd/bdui-lightbox';
import PageHelmet from '@bd/bdcore-pagehelmet';


import Header from '../../components/Header';
import Footer from '../../components/Footer';
import InsideHeader from '../../components/InsideHeader';
import PageIntroBanner from '../../components/PageIntroBanner';
import TestimonialBanner from '../../components/TestimonialBanner';
import CtaBanner from '../../components/CtaBanner';
import MenuAbout from '../../components/MenuAbout';

function Difference({ page }) {
  if (!page) {
    return null;
  }

  return (
    <div>
      <InsideHeader h1="The 70 West Difference" background={get(page, 'page_image.contentUrl')} />
      <PageHelmet page={page} />
      <Header />
      <MenuAbout />
      <PageIntroBanner
        h2={get(page, 'intro_banner[0].top_headline')}
        h3={get(page, 'intro_banner[0].main_headline')}
        p={get(page, 'intro_banner[0].paragraph')}
        background={get(page, 'intro_banner[0].photo.contentUrl')}
      />
      {
        page.page_section.map(item => (
          <section key={item.headline} className="section-pd section-alternate">
            <div className="full-width-headline-left">
              <div className="container">
                <h3>{item.headline}</h3>
              </div>
              <div className="lines" />
            </div>
            <div className="container">
              <div className="row">
                <div className="col-lg-6" dangerouslySetInnerHTML={SanitizeHtml(get(item, 'text'))} />
                <div className="col-lg-5">
                  <LightBox
                    items={[item.photo]}
                    button={(
                      <div className="result-media bg-cover" style={{ backgroundImage: `url(${buildThumbnailUrl(get(item, 'photo.contentUrl'), { width: 800, height: 800 })})` }} />
                    )}
                  />
                </div>
              </div>
            </div>
          </section>
        ))
      }
      <TestimonialBanner />
      <CtaBanner />
      <Footer />
    </div>
  );
}

Difference.propTypes = {
  page: PropTypes.object,
};

Difference.defaultProps = {
  page: undefined,
};

export default withData({
  page: 'about_us',
})(Difference);



// WEBPACK FOOTER //
// ./src/pages/Difference/index.js